import { throttle } from "lodash";
import { onHeaderLargeScreen } from "./breakpoint-detect";

declare const jQuery: any;
const $ = jQuery;

export function initLogoLinkAltImages(): void
{
	const $imgs = $(`.logo-link img[data-mobile-src],.logo-link img[data-lg-scrolled-src]`);
	if ($imgs.length === 0)
	{
		return;
	}
	const $body = $(document.body);
	$imgs.each(function () {
		const $img = $(this);
		const lgSrc = $img.attr("src");
		const smSrc = $img.attr("data-mobile-src") || lgSrc;
		const lgScrolledSrc = $img.attr("data-lg-scrolled-src") || lgSrc;
		const smScrolledSrc = $img.attr("data-sm-scrolled-src") || smSrc;
		let mobileSrcDisabled = false;
		let lgScrolledSrcDisabled = false;
		let smScrolledSrcDisabled = false;
		const fix = () => {
			const onLargeScreen: boolean = onHeaderLargeScreen();
			let src: string = (onLargeScreen || mobileSrcDisabled) ? lgSrc : smSrc;
			if ($body.hasClass("scrolled"))
			{
				if (onLargeScreen)
				{
					if (!lgScrolledSrcDisabled)
					{
						src = lgScrolledSrc;
					}
				}
				else
				{
					if (!smScrolledSrcDisabled)
					{
						src = smScrolledSrc;
					}
				}
			}
			$img.attr({ src });
		};
		fix();
		if ($img.is("[data-mobile-src]"))
		{
			$img.removeAttr("data-mobile-src").attr("data-mobile-src-done", "").on("disable-mobile-src", () => {
				mobileSrcDisabled = true;
			}).on("enable-mobile-src", () => {
				mobileSrcDisabled = false;
			});
		}
		if ($img.is("[data-lg-scrolled-src]"))
		{
			$img.removeAttr("data-lg-scrolled-src").attr("data-lg-scrolled-src-done", "").on("disable-lg-scrolled-src", () => {
				lgScrolledSrcDisabled = true;
			}).on("enable-lg-scrolled-src", () => {
				lgScrolledSrcDisabled = false;
			});
		}
		if ($img.is("[data-sm-scrolled-src]"))
		{
			$img.removeAttr("data-sm-scrolled-src").attr("data-sm-scrolled-src-done", "").on("disable-sm-scrolled-src", () => {
				smScrolledSrcDisabled = true;
			}).on("enable-lg-scrolled-src", () => {
				smScrolledSrcDisabled = false;
			});
		}
		const throttledFix = throttle(fix, 99, { leading: true, trailing: true });
		$(window).on("resize load", throttledFix);
		$body.on("scrolled unscrolled", throttledFix);
	});
}
